import { render, staticRenderFns } from "./Training_management.vue?vue&type=template&id=7906bf10"
import script from "./Training_management.vue?vue&type=script&lang=js"
export * from "./Training_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports